<template>
  <div class="start-with">
    <h3 class="block-title">{{ __('website.tariffs.get_started') }}</h3>
    <CustomBtn @click="openDemoModal">{{ __('website.tariffs.cta.book_demo') }}</CustomBtn>
  </div>
</template>

<script>
import { openDemoModal } from '@/utils';

import CustomBtn from './CustomBtn.vue';

export default {
  name: 'StartWIth',

  components: {
    CustomBtn,
  },

  methods: {
    openDemoModal,
  },
};
</script>

<style lang="sass" scoped>
.start-with
  max-width: 1135px
  margin: 60px auto 55px
  border-radius: 20px
  overflow: hidden
  background: url(https://hurma.work/wp-content/uploads/2022/07/start_with_hurma.jpg) center -2px
  padding: 90px 0
  text-align: center
.block-title
  color: #fff
  font-size: 48px
  line-height: 60px
  font-weight: 700
  margin: 0 0 32px

@media screen and (max-width: 990px)
  .start-with
    padding: 70px 0
    margin: 40px 0
  .block-title
    font-size: 32px
    line-height: 48px
</style>